import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { authService } from "../services/backend";
import Loading from "./Loading";

const ProtectedRoute = ({ children, requiredRole }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const currentUser = await authService.getCurrentUser();
        setUser(currentUser);
      } catch (error) {
        console.error("Auth check failed:", error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return <Loading />;
  }

  // 1. Not Logged In -> Redirect to appropriate Login
  if (!user) {
    return (
      <Navigate
        to={requiredRole === "admin" ? "/admin/login" : "/reseller/login"}
        replace
      />
    );
  }

  // 2. Admins can access everything (if OTP is verified)
  if (user.role === "admin") {
    if (requiredRole === "admin" && !sessionStorage.getItem("otpVerified")) {
      // If trying to access admin dashboard without OTP verification, redirect to login
      return <Navigate to="/admin/login" replace />;
    }
    return children;
  }

  // 3. Non-admin trying to access admin-only route -> Block
  if (requiredRole === "admin" && user.role !== "admin") {
    return <Navigate to="/reseller/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
